import React, { useEffect, useState } from "react";

export const ScrollProgress = () => {
  const [p, setP] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      const pct = total > 0 ? (h.scrollTop / total) * 100 : 0;
      setP(pct);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] pointer-events-none"
    >
      <div
        className="h-full bg-gradient-to-r from-[#A88824] via-[#D4AF37] to-[#E6C35C] transition-[width] duration-150 ease-out shadow-[0_0_12px_rgba(212,175,55,0.6)]"
        style={{ width: `${p}%` }}
      />
    </div>
  );
};
